module.exports = __webpack_public_path__ + "img/video.c43727ec.png";